import React from 'react';
import './Card.css';
import { Fade } from 'react-awesome-reveal';

/* Added on 31126 */
const paperTitles = {
  "https://pubmed.ncbi.nlm.nih.gov/35171654": "Spatial transcriptomics of dorsal root ganglia identifies molecular signatures of human nociceptors",
  "https://doi.org/10.1093/brain/awac266": "RNA profiling of human dorsal root ganglia reveals sex differences in mechanisms promoting neuropathic pain",
  "https://journals.lww.com/pain/fulltext/2024/11000/rna_isoform_expression_landscape_of_the_human.10.aspx": "RNA isoform expression landscape of the human dorsal root ganglion generated from long-read sequencing",
  "https://pubmed.ncbi.nlm.nih.gov/33727337/": "A ligand-receptor interactome platform for discovery of pain mechanisms and therapeutic targets",
  "https://journals.lww.com/pain/fulltext/2018/07000/comparative_transcriptome_profiling_of_the_human.16.aspx": "Comparative Transcriptome Profiling of the Human and Mouse DRG",
  "https://academic.oup.com/brain/article/142/5/1215/5382382": "Neuropathic Pain in Human DRG Neurons",
  "https://journals.lww.com/pain/fulltext/2020/07000/pharmacological_target_focused_transcriptomic.9.aspx": "Pharmacological Target-Focused Transcriptomic Analysis of Native vs Cultured Human and Mouse DRG",
  "https://journals.lww.com/pain/fulltext/2025/10000/multi_omic_integration_with_human_dorsal_root.21.aspx": "Multi-omic integration with human dorsal root ganglia proteomics highlights TNFα signalling as a relevant sexually dimorphic pathway",
  "https://www.biorxiv.org/content/10.1101/2025.02.19.639130v1": "Single-nuclei RNA Sequencing Reveals Distinct Transcriptomic Signatures of Rat Dorsal Root Ganglia in a Chronic Discogenic Low Back Pain Model",
  "https://www.biorxiv.org/content/10.1101/2025.06.24.661373v1": "Spatial transcriptomic profiling of human paravertebral sympathetic chain ganglia reveals diabetes-induced neuroplasticity",
  "https://www.jci.org/articles/view/184075": "Cell and molecular profiles in peripheral nerves shift toward inflammatory phenotypes in diabetic peripheral neuropathy",
  "https://academic.oup.com/brain/advance-article/doi/10.1093/brain/awaf370/8270764?login=true": "Transcriptome of the human C2 dorsal root ganglia in C1-2 arthrodesis surgery: insight for neck pain",
  "https://www.biorxiv.org/content/10.1101/2025.10.31.685953v2": "A molecular map of the human spinal dorsal and ventral horn defines arrangement of neuronal types and glial sex differences",
  "https://www.cell.com/cell/fulltext/S0092-8674(25)01497-7" : "Molecular architecture of human dermal sleeping nociceptors",
  "https://www.nature.com/articles/s41467-026-74144-3": "Spinal signatures of entrenched and treated neuropathic pain in male mice"
};

const Card = ({ title, description, link, paperLinks, imageUrl}) => {
  return (
    <Fade direction='up' duration={1300} triggerOnce>
      <div className='card-container'>
        <div className="card">
          <div className='card-content'>
            <div className='card-footer'>
              <h3>{title}</h3>
            </div>
            <div className='card-footer'>
              <p>{description}</p>
            </div>
            {paperLinks?.length > 0 && (
              <div className='card-footer' style={{ flexDirection: 'column', alignItems: 'flex-start' }}>
                {paperLinks.map((url, i) => (
                  <p key={i}style={{ margin: 0 }}><strong>Paper Title:</strong> {paperTitles[url] ?? url}</p>
                ))}
              </div>
            )}
             <div className='card-button'>
              <a href={link} target="_blank" rel="noopener noreferrer" className="button">
                Visit Site
              </a>
              {/*
              {paperLinks && <a href={paperLinks} target="_blank" rel="noopener noreferrer" className="button">
                Read Paper
              </a>} */}
            </div> 
          </div> 
          {/* <style>
        {`
          .card::before {
            background-image: url(${imageUrl});
          }
        `}
      </style> */}
        </div>
      </div>
    </Fade>
  );
};

export default Card;